module.exports = __webpack_public_path__ + "img/pending_message.5010fd08.png";